import { Box, Typography } from "@dealer-center/core-components";
import type { HeaderProps } from "@dealer-center/ddc-pages-nrt-provider-config-tool-interface";

export const Header = ({ subtitle, title }: HeaderProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
    <Typography variant="h1">{title}</Typography>
    <Typography variant="body-md">{subtitle}</Typography>
  </Box>
);
